import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router-dom'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { SparkleIcon } from './NewDesignChip'

import './index.css'

const CLOSED_KEY = 'sf-legacy-bar'

// Screens still in the old design (William, 1 Nov 2026 + staging leftovers). Remove an entry when
// its page moves to the new design. Admin routes stay out of scope.
const EVENT_PAGES = ['live/settings', 'planning/stream-config', 'qualified']
export const LEGACY_PATHS = [
    ...['/:eventIdentifier', '/sporthub/:eventIdentifier'].flatMap((prefix) =>
        EVENT_PAGES.map((page) => `${prefix}/${page}`),
    ),
    '/buzzers-results',
    '/partner-external-api-config',
    '/partner-external-api-config/:eventId',
]

const isClosed = () => {
    try {
        return localStorage.getItem(CLOSED_KEY) === 'closed'
    } catch {
        return false
    }
}

/**
 * "Previous interface" bar (mock `.legacy-bar` on register.html): in flow right under the nav on
 * pages that have not moved to the new design, so the visitor knows it is not a bug. Monochrome,
 * dismissed once for good (`sf-legacy-bar`).
 */
export default function LegacyBar() {
    const { t } = useTranslation(TranslationNS.DESIGN_TRANSITION)
    const location = useLocation()
    const [closed, setClosed] = useState(isClosed)

    if (closed || !LEGACY_PATHS.some((pattern) => matchPath(pattern, location.pathname))) return null

    const close = () => {
        try {
            localStorage.setItem(CLOSED_KEY, 'closed')
        } catch {
            /* private mode: comes back next visit */
        }
        setClosed(true)
    }

    return (
        <div className="legacy-bar" role="status">
            <SparkleIcon className="legacy-ico" />
            <p className="legacy-txt">
                <b>{t('Previous interface.')}</b> {t("This page hasn't moved to the new scoring.fit design yet.")}
            </p>
            <button type="button" className="legacy-close" aria-label={t('Close')} onClick={close}>
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    aria-hidden="true"
                >
                    <path d="M6 6l12 12M18 6 6 18" />
                </svg>
            </button>
        </div>
    )
}
